// (A) 중립 다이얼로그 API — antd 미접촉. state 기반 선언형(imperative Modal.confirm 미사용).
import type { CSSProperties, ReactNode } from 'react'
import { PlainDialog } from '../_impl/PlainDialog'

export interface OmwDialogProps {
  open: boolean
  title?: ReactNode
  onClose?: () => void
  /** 커스텀 footer. 미지정 시 footer 없음(antd 기본 OK/Cancel 버튼 비노출). */
  footer?: ReactNode
  width?: number | string
  /** 닫기(X) 버튼 노출 여부. 기본 true. */
  closable?: boolean
  /** 세로 중앙 정렬. */
  centered?: boolean
  /** 닫힐 때 자식 트리 파기. */
  destroyOnHidden?: boolean
  /** 모달 wrapper 클래스(antd wrapClassName). */
  wrapClassName?: string
  /** 명시 z-index(antd zIndex). 미지정 시 열림 순서대로 자동 스태킹(먼저 열린 모달 위로). */
  zIndex?: number
  /** 콘텐츠 박스 스타일(padding:0 등 — antd modalRender 대체). */
  contentStyle?: CSSProperties
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwDialog(props: OmwDialogProps) {
  return <PlainDialog {...props} />
}
